import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  CATEGORY,
  CATEGORY_ALL,
  CATEGORY_CREATE,
  CATEGORY_DELETE,
  CATEGORY_LIST,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const categorysSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const categorySelector = createSelector(categorysSelector, data => data[CATEGORY])

export const categoryAllSelector = createSelector(categorysSelector, data => data[CATEGORY_ALL])

export const categoryCreateSelector = createSelector(categorysSelector, data => data[CATEGORY_CREATE])

export const categoryDeleteSelector = createSelector(categorysSelector, data => data[CATEGORY_DELETE])

export const categoryListSelector = createSelector(categorysSelector, data => data[CATEGORY_LIST])
